import { RemoteCancelScheduledPushNotification } from 'data/usecases';
import { CancelScheduledPushNotificationUseCaseInterface } from 'domain/usecases';
import { makeApiUrlCancelScheduledPushNotification } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeCancelScheduledPushNotification =
  (): CancelScheduledPushNotificationUseCaseInterface =>
    new RemoteCancelScheduledPushNotification(
      makeApiUrlCancelScheduledPushNotification(),
      makeAxiosHttpClient(),
    );
